const editData = (cms, isVariant, isAttachment, ecommercePlatform, isVariable) => {
  const filterTab = [
    {
      id: "information",
      content: cms("label.information"),
      panelID: "information-content",
    },
  ];
  if (!isVariant) {
    filterTab.push({
      id: "inventory",
      content: cms("label.inventory"),
      panelID: "inventory-content",
    });
  }
  filterTab.push({
    id: "image",
    content: cms("label.image"),
    panelID: "image-content",
  });
  if (isVariant || isVariable) {
    filterTab.push({
      id: "variant",
      content: cms("label.variant"),
      panelID: "variant-content",
    });
  }
  if (!isVariant) {
    filterTab.push({
      id: "fulfillment",
      content: cms("label.fulfillment"),
      panelID: "fulfillment-content",
    });
  }
  if (isAttachment) {
    filterTab.push({
      id: "attachment",
      content: cms("label.attachment"),
      panelID: "attachment-content",
    });
  }
  return {
    option: {
      option1: "option1",
      option2: "option2",
      option3: "option3",
    },
    policyOption: [
      {
        label: cms("label.notTrack"),
        value: "Don't track inventory",
      },
      {
        label: cms("label.shopify", { item: ecommercePlatform }),
        value: "shopify",
      },
    ],
    tabs: filterTab,
  };
};

export default editData;
